import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

type QRCodeTipProps = {
  isFHSBrand: boolean;
};

export const QRCodeWrapper = styled.div`
  text-align: center;

  & > canvas {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
`;

export const QRCodeTip = styled.p<QRCodeTipProps>`
  font: var(--font-copyTwo);
  margin: 0 0 ${primitive.$spacing4};
  color: ${({ isFHSBrand }) => isFHSBrand && primitive.fhs.$houseNavy};
`;
